let isPopupLocked = false;
let currentMarker = null;

function positionMarkers() {
  const map = document.getElementById("mapImage");
  const markers = document.querySelectorAll(".marker");

  markers.forEach((marker) => {
    const xPercent = marker.getAttribute("data-x");
    const yPercent = marker.getAttribute("data-y");

    marker.style.left = (map.clientWidth * xPercent) / 100 + "px";
    marker.style.top = (map.clientHeight * yPercent) / 100 + "px";
  });
}

document.querySelector(".map-container");
// .addEventListener("scroll", function (e) {
//   alert("Section is scrolling", e);
// });

function preventPopupOverflow(marker, popup) {
  const map = document.getElementById("mapImage");
  const mapRect = map.getBoundingClientRect(); // get the position of the map on screen

  let leftPos = mapRect.left + marker.offsetLeft - popup.offsetWidth / 2 + 10;
  let topPos = mapRect.top + marker.offsetTop - popup.offsetHeight - 15;

  const screenPadding = 10;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  if (leftPos < screenPadding) {
    leftPos = screenPadding;
  }
  if (leftPos + popup.offsetWidth > screenWidth - screenPadding) {
    leftPos = screenWidth - popup.offsetWidth - screenPadding;
  }
  if (topPos < screenPadding) {
    topPos = mapRect.top + marker.offsetTop + 20;
  }
  if (topPos + popup.offsetHeight > screenHeight - screenPadding) {
    topPos = screenHeight - popup.offsetHeight - screenPadding;
  }

  popup.style.left = leftPos + "px";
  popup.style.top = topPos + "px";
}

window.onload = positionMarkers;
window.onresize = positionMarkers;

document.addEventListener("DOMContentLoaded", function () {
  const markers = document.querySelectorAll(".marker");
  const popup = document.getElementById("popup");
  const popupContent = document.getElementById("popupContent");
  const popupCloseBtn = document.getElementById("popupCloseBtn");

  markers.forEach((marker) => {
    marker.addEventListener("mouseenter", function () {
      if (isPopupLocked) return;
      popupContent.innerHTML = marker.getAttribute("data-info");
      popup.style.display = "block";
      preventPopupOverflow(marker, popup);
      setTimeout(() => popup.classList.add("show"), 10);
    });

    marker.addEventListener("mouseleave", function () {
      if (isPopupLocked) return;
      popup.classList.remove("show");
      setTimeout(() => {
        if (!popup.classList.contains("show")) {
          popup.style.display = "none";
        }
      }, 300);
    });

    marker.addEventListener("click", function (e) {
      e.stopPropagation();
      isPopupLocked = true;
      currentMarker = marker;

      popupContent.innerHTML = marker.getAttribute("data-info");
      popup.style.display = "block";
      preventPopupOverflow(marker, popup);
      popup.classList.add("show");
    });
  });

  document.addEventListener("click", function (e) {
    if (isPopupLocked && !popup.contains(e.target)) {
      closePopup();
    }
  });

  popupCloseBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    closePopup();
  });

  function closePopup() {
    isPopupLocked = false;
    currentMarker = null;

    popup.classList.remove("show");
    setTimeout(() => {
      if (!popup.classList.contains("show")) {
        popup.style.display = "none";
      }
    }, 300);
  }
});
